import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket, faCheck } from "@fortawesome/free-solid-svg-icons";
import "./Regisration.css"
import { useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import ExternalAuth from "./ExternalAuth";
import { Container } from "react-bootstrap";
import axios from "axios";
import Countdown from "react-countdown";



function Registration() {

  //Куки промо кода
  //const [cookiesPromo, setCookiePromo, removeCookiePromo] = useCookies(['biz_promo']);

  const [searchParams, setSearchParams] = useSearchParams();
  const [cookies, setCookie, removeCookie] = useCookies(['biz_outh_srv']);

  useEffect(() => {
    const srv = searchParams.get("srv");
    const promo = searchParams.get("promo");

    if (srv !== null) {
      setCookie('biz_outh_srv', srv)
    }
    if (promo !== null) {
      setCookie('biz_promo', promo, { path: '/', maxAge: 604800, secure: true })//На 7 дней
      setPromo(promo);
    }
  }, []);

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [val, setVal] = useState(null);
  const [code, setCode] = useState(null);
  const [name, setName] = useState(null);
  const [promo, setPromo] = useState(null);
  const [password, setPassword] = useState(null);
  const [passwordConfirm, setPasswordConfirm] = useState(null);
  const [codeEnd, setCodeEnd] = useState(null);

  const [step, setStep] = useState(1);

  //Предварительная регистрация и отправка кода подтверждения
  function hundlerRegisterBefore() {
    setLog(null);
    setLoading(true);

    if (name === null || name === '' || name === undefined) {
      setLoading(false);
      setLog('Введите имя');
    }
    else if (val === null || val === '' || val === undefined) {
      setLoading(false);
      setLog('Введите email или номер телефона');
    }
    else if (password === null || password === '' || password === undefined) {
      setLoading(false);
      setLog('Введите пароль');
    }
    else if (passwordConfirm === null || passwordConfirm === '' || passwordConfirm === undefined) {
      setLoading(false);
      setLog('Введите пароль еще раз');
    }
    else if (passwordConfirm !== password) {
      setLoading(false);
      setLog('Пароли не совпадают');
    }
    else if (password.length < 8) {
      setLoading(false);
      setLog('Пароль должен содержать минимум 8 символов');
    }
    else {
      axios.post('/api/user/registerBefore', { Val: val })
        .then((res) => {
          console.log('res.data', res.data)
          if (res.data.Status === 1) {
            setStep(2);
            setCodeEnd(res.data.Data.Code_End)
            setLoading(false);
          }
          else {
            setLog(res.data.Error);
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
          setLog('Неизвестная ошибка!');
        })
    }
  }
  function hundlerRegisterFinish() {
    setLog(null);
    setLoading(true);

    if (code === null || code === '' || code === undefined) {
      setLoading(false);
      setLog('Введите код подтверждения');
    }
    else {
      axios.post('/api/user/register', { Name: name, Val: val, Code: code, Password: password, Confirm_Password: passwordConfirm, Promo: promo })
        .then((res) => {
          if (res.data.Status === 1) {
            const srv = cookies.biz_outh_srv;
            //Если трекер
            if (srv === 2) {
              return window.location.replace(process.env.REACT_APP_DOMAIN_TRACKER + '/lk');
            }
            else {
              return window.location.replace(process.env.REACT_APP_DOMAIN_MAIN);
            }
          }
          else {
            setLog(res.data.Error);
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
          setLog('Неизвестная ошибка!');
        })
    }
  }
  return (
    <>
      <Container>
        <h1 className="text-center mt-3 mt-lg-5 mb-3 mb-lg-5">Регистрация</h1>

        {step === 1 && (
          <>
            <div className="row mb-3">
              <div className="col-lg-4"></div>
              <div className="col-lg-4">
                <div className="block_form">
                  <Form.Group className="mb-3">
                    <Form.Label>Имя</Form.Label>
                    <Form.Control type="text" disabled={loading} onChange={(e) => setName(e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="text" disabled={loading} onChange={(e) => setVal(e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-3 mt-3">
                    <Form.Label>Пароль</Form.Label>
                    <Form.Control type="password" disabled={loading} onChange={(e) => setPassword(e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-3 mt-3">
                    <Form.Label>Пароль еще раз</Form.Label>
                    <Form.Control type="password" disabled={loading} onChange={(e) => setPasswordConfirm(e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Promo код</Form.Label>
                    <Form.Control type="text" disabled={loading} onChange={(e) => setPromo(e.target.value)} value={promo} />
                  </Form.Group>
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <Button variant="light" className="btn_form" disabled={loading} onClick={() => hundlerRegisterBefore()}><FontAwesomeIcon icon={faArrowRightFromBracket} style={{ marginRight: "5px" }} />Регистрация</Button>
                    </div>
                  </div>

                  {log !== null && (
                    <div className="row mb-3">
                      <div className="col-md-12 log_form_light">{log}</div>
                    </div>
                  )}

                  <div className="text-center mb-4"><strong>ИЛИ В ОДИН КЛИК:</strong></div>
                  <ExternalAuth />
                </div>
              </div>
              <div className="col-lg-4"></div>
            </div>

          </>
        )}
        {step === 2 && (
          <>
            <div className="row mb-3">
              <div className="col-lg-4"></div>
              <div className="col-lg-4">
                <div className="block_form">
                  <div className="text-center">
                    <i>На указанный адрес электронной почты <br></br> <b>{val}</b> <br></br> выслан код подтверждения.</i>
                  </div>
                  <Form.Group className="mb-4 mt-4">
                    <Form.Label>Введите код подтверждения</Form.Label>
                    <Form.Control type="text" disabled={loading} onChange={(e) => setCode(e.target.value)} />
                  </Form.Group>
                  {log !== null && (
                    <div className="row mb-3">
                      <div className="col-lg-12 log_form">{log}</div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <Button variant="light" disabled={loading} onClick={() => hundlerRegisterFinish()}><FontAwesomeIcon icon={faCheck} style={{ marginRight: "5px" }} />Подтвердить</Button>
                    </div>
                  </div>
                  <div className="text-center mt-3">
                    <Countdown date={codeEnd}>
                      <a href="" className="block_form_link" onClick={(e) => { e.preventDefault(); hundlerRegisterBefore() }}>Повторить отправку кода</a>
                    </Countdown>
                  </div>
                </div>
              </div>
              <div className="col-lg-4"></div>
            </div>
          </>
        )}

      </Container>
    </>
  );

}

export default Registration;
